import { watch } from 'vue';
import { syncAnalyticsConsent } from '@/services/analytics';
import { isAnalyticsEnabled } from '@/services/analytics/config';
import { clearUnconsentedTrackingStorage } from '@/services/analytics/storage';
import { useCookieConsentStore } from '@/stores/useCookieConsentStore';
import { hasCookieConsentWithdrawal } from '@/utils/cookieConsent.utils';

export function useAnalyticsConsentSync(): void {
  const consentStore = useCookieConsentStore();
  consentStore.init();
  if (!isAnalyticsEnabled()) return;

  watch(
    () => consentStore.consent,
    (consent, previous) => {
      syncAnalyticsConsent();
      clearUnconsentedTrackingStorage(consent);
      if (hasCookieConsentWithdrawal(previous ?? null, consent)) {
        // Removing scripts cannot stop SDK timers/listeners. The choice is already saved.
        window.location.reload();
      }
    },
    { immediate: true, flush: 'sync' },
  );
}
